import { createFileRoute } from '@tanstack/react-router';
import { DashboardMorning } from '~/components/dashboard-morning';
import { DashboardStats } from '~/components/dashboard-stats';

export const Route = createFileRoute('/_authenticated/')({
    component: HomePage,
});

function HomePage() {
    return (
        <div className="flex flex-col gap-4 p-6">
            <DashboardStats />
            <DashboardMorning />
        </div>
    );
}
